import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import DatePeriodPicker from '@/components/common/dateperiodpicker/DatePeriodPicker.vue'

const defaultEl = {
  id: null,
  material: null,
  rate: '',
  isAllowed: 1,
  from_date_period_id: null,
  to_date_period_id: null
};

export default {
  name: 'MaterialRateEdit',
  props: ['clientApiId'],
  components: {
    DatePeriodPicker
  },
  data () {
    return {
      editEl: this.BasicHelper.cloneObject(defaultEl),
      loading: false
    }
  },
  validations: {
    editEl: {
      material: { required },
      from_date_period_id: { required }
    }
  },
  computed: {
    ...mapState(['config']),
    getTitle () {
      if (this.clientApiId) {
        if (this.editEl.id) {
          return this.$t('menu.material-rate.client.edit');
        }
        return this.$t('menu.material-rate.client.new');
      }
      if (this.editEl.id) {
        return this.$t('menu.material-rate.edit');
      }
      return this.$t('menu.material-rate.new');
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    }
  },
  methods: {
    changeAllowed (val) {
      if (val === 0) {
        this.editEl.rate = '';
      }
    },
    show (elData, materialId = null) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
        if (materialId) {
          this.editEl.material_id = materialId;
        }
      }
      this.editEl.material = this.$store.getters.getParamFromConfig('materials', this.editEl.material_id, 'code');
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
        }
        const self = this;
        let path = 'material/material/rates/' + this.editEl.material + '/edit';
        if (this.clientApiId) {
          path = 'client/single/' + this.clientApiId + '/material-rates/edit';
        }
        this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, { material_rate: reqData }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
